let EmailService = function (Restangular) {
  const Email = Restangular.all('admin/pre_attendance_email');

  let count = (query) => {
    query = query || {};
    query.deleted_at = 'null';
    return Email.customGET('count', query);
  }

  let save = (resource) => {
    if (resource.save) {
        return resource.patch();
    } else {
        return Email.post(resource);
    }
  }

  let index = (query) => {
    query = query || {};
    query.deleted_at = 'null';
    return Email.getList(query);
  }

  let load = (query) => {
    query = query || {};
    query.deleted_at = 'null';
    return new Promise((resolve, reject) => {
        count(query)
        .then(response => {
            let count = response[0];
            index(query)
            .then(data => {
                resolve({count, data});
            })
            .catch(err => {
                reject(err);
            });
        })
        .catch(err => {
            reject(err);
        });
    });
  }

  let show = (id) => {
    return Email.get(id);
  }

  let destroy = (resource) => {
    resource.deleted_at = moment();
    return resource.save();
  }

  return { index, load, save, show, destroy } ;
};

EmailService.$inject = ['Restangular'];

export default EmailService;



// WEBPACK FOOTER //
// ./client/app/components/email/email.service.js